import { useJobs } from '../hooks/queries/useJobs';
import { HiOutlineLightningBolt } from 'react-icons/hi';
import TitleWIthDescription from '../components/TitleWithDesc/TitleWIthDescription';
import JobCard from '../components/JobCard/Jobcard';
import JobCardSkeleton from '../components/JobCard/JobCardSkeleton';

const JobPosting = () => {
  const { isLoading: loading, data: Jobs } = useJobs();

  return (
    <div className="max-w-7xl mx-auto pb-20">
      <TitleWIthDescription
        title1="Career Opportunities"
        title2="Just For You!"
        description="Handpicked openings from top companies to help you land your dream campus placement."
      />

      {/* Message Bar / Quick Stats */}
      <div className="px-4 mb-8">
        <div className="bg-slate-900 rounded-3xl p-4 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-xl shadow-slate-100">
          <div className="flex items-center gap-3 ml-2">
            <div className="bg-blue-500 p-2 rounded-xl text-white">
              <HiOutlineLightningBolt size={20} />
            </div>
            <div>
              <p className="text-white text-sm font-black">Daily Updates</p>
              <p className="text-slate-400 text-[11px] font-bold uppercase tracking-widest">New jobs added every 24 hours</p>
            </div>
          </div>

          <div className="flex items-center gap-6 mr-4">
            <div className="text-center">
              <p className="text-blue-400 text-lg font-black">{Jobs?.job?.length || 0}</p>
              <p className="text-slate-500 text-[9px] font-black uppercase">Active Leads</p>
            </div>
            <div className="h-8 w-px bg-slate-800 hidden sm:block"></div>
            <div className="text-center">
              <p className="text-white text-lg font-black">100%</p>
              <p className="text-slate-500 text-[9px] font-black uppercase">Verified</p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4">
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 py-10">
            {[1, 2, 3].map((i) => (
              <JobCardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {Jobs?.job?.map((job) => (
              <JobCard key={job._id} job={job} />
            ))}
          </div>
        )}

        {!loading && Jobs?.job?.length === 0 && (
          <div className="text-center py-20 bg-slate-50 rounded-[3rem] border-2 border-dashed border-slate-200">
            <p className="text-slate-400 font-bold">No new openings found. Check back later!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobPosting;